// Auto-generated by scripts/generate-registry.mjs from packages/modules/e27_low_base/ui-config.json — DO NOT EDIT MANUALLY!
import type { ModuleSchema } from './types.js';

export const e27_low_base: ModuleSchema = {
  "id": "e27_low_base",
  "uniqueId": "B3D_E27LB",
  "createdAt": "2026-10-02T07:59:47.499Z",
  "updatedAt": "2026-10-28T14:58:33.698Z",
  "label": "Low E27 Base",
  "description": "E27 low profile base with central threaded post (M60) and retaining clamp ring",
  "category": "lighting",
  "tags": [
    "e27",
    "lighting",
    "lamp",
    "threaded_base",
    "assembly"
  ],
  "sliders": [
    {
      "key": "lowBaseDia",
      "label": "Base Diameter",
      "min": 100,
      "max": 180,
      "default": 130,
      "step": 1,
      "unit": "mm",
      "category": "dimensions",
      "enabled": true,
      "visible": true
    },
    {
      "key": "lowBaseH",
      "label": "Base Height",
      "min": 25,
      "max": 60,
      "default": 35,
      "step": 1,
      "unit": "mm",
      "category": "dimensions",
      "enabled": true,
      "visible": true
    },
    {
      "key": "towerH",
      "label": "Threaded Post Height",
      "min": 15,
      "max": 40,
      "default": 25,
      "step": 1,
      "unit": "mm",
      "category": "dimensions",
      "enabled": true,
      "visible": true
    },
    {
      "key": "e27HoleDia",
      "label": "Socket Center Hole in Post",
      "min": 35,
      "max": 45,
      "default": 41.5,
      "step": 0.5,
      "unit": "mm",
      "category": "dimensions",
      "enabled": true,
      "visible": true
    },
    {
      "key": "shadeHoleDia",
      "label": "Shade Bottom Hole (for M60 Post)",
      "min": 58,
      "max": 68,
      "default": 61,
      "step": 0.5,
      "unit": "mm",
      "category": "dimensions",
      "enabled": true,
      "visible": true
    },
    {
      "key": "ringOuterDia",
      "label": "Locking Ring Outer Diameter",
      "min": 65,
      "max": 85,
      "default": 70,
      "step": 1,
      "unit": "mm",
      "category": "dimensions",
      "enabled": true,
      "visible": true
    },
    {
      "key": "shadeH",
      "label": "Lampshade Height",
      "min": 100,
      "max": 350,
      "default": 170,
      "step": 10,
      "unit": "mm",
      "category": "dimensions",
      "enabled": true,
      "visible": true
    },
    {
      "key": "shadeWall",
      "label": "Shade Wall Thickness",
      "min": 1,
      "max": 4,
      "default": 2,
      "step": 0.5,
      "unit": "mm",
      "category": "dimensions",
      "enabled": true,
      "visible": true
    },
    {
      "key": "shadeBottomThick",
      "label": "Shade Bottom Disc Thickness",
      "min": 2,
      "max": 6,
      "default": 2,
      "step": 0.5,
      "unit": "mm",
      "category": "dimensions",
      "enabled": true,
      "visible": true
    },
    {
      "key": "patternType",
      "label": "Pattern Hole Shape",
      "min": 0,
      "max": 2,
      "default": 0,
      "step": 1,
      "unit": "",
      "category": "patterns",
      "enabled": true,
      "visible": true
    },
    {
      "key": "patternSize",
      "label": "Pattern Hole Size",
      "min": 3,
      "max": 18,
      "default": 8,
      "step": 1,
      "unit": "mm",
      "category": "patterns",
      "enabled": true,
      "visible": true
    },
    {
      "key": "patternRows",
      "label": "Pattern Rows",
      "min": 4,
      "max": 30,
      "default": 16,
      "step": 1,
      "unit": "",
      "category": "patterns",
      "enabled": true,
      "visible": true
    },
    {
      "key": "patternCols",
      "label": "Pattern Columns",
      "min": 4,
      "max": 24,
      "default": 12,
      "step": 1,
      "unit": "",
      "category": "patterns",
      "enabled": true,
      "visible": true
    }
  ],
  "selects": [],
  "textParams": [],
  "colorConfigs": [
    {
      "key": "collar_ring",
      "label": "M60 Locking Ring",
      "default": "#D97706",
      "targetGroupIds": [
        3
      ]
    },
    {
      "key": "shade_body",
      "label": "Lampshade Body",
      "default": "#F3F4F6",
      "targetGroupIds": [
        0
      ]
    },
    {
      "key": "low_base",
      "label": "Low Threaded Base",
      "default": "#7C2D12",
      "targetGroupIds": [
        1
      ]
    },
    {
      "key": "screw_feet",
      "label": "4x Male Feet Screws",
      "default": "#9CA3AF",
      "targetGroupIds": [
        2
      ]
    }
  ],
  "objects": [
    {
      "id": "ring_obj",
      "label": "M60 Locking Ring",
      "name": "M60 Locking Ring",
      "color": "#D97706",
      "assembled_z_offset": 0,
      "exploded_z_offset": 120,
      "parts": [
        {
          "id": "collar_ring",
          "label": "M60 Locking Ring",
          "name": "M60 Locking Ring",
          "groupId": 3,
          "colorKey": "collar_ring",
          "defaultColor": "#D97706",
          "assembled_z_offset": 0,
          "exploded_z_offset": 120,
          "export_stl": true
        }
      ]
    },
    {
      "id": "shade_obj",
      "label": "Cylindrical Patterned Lampshade",
      "name": "Cylindrical Patterned Lampshade",
      "color": "#F3F4F6",
      "assembled_z_offset": 0,
      "exploded_z_offset": 70,
      "parts": [
        {
          "id": "shade_body",
          "label": "Lampshade Body",
          "name": "Lampshade Body",
          "groupId": 0,
          "colorKey": "shade_body",
          "defaultColor": "#F3F4F6",
          "assembled_z_offset": 0,
          "exploded_z_offset": 70,
          "export_stl": true
        }
      ]
    },
    {
      "id": "base_obj",
      "label": "Low Threaded Base (Ø130mm)",
      "name": "Low Threaded Base (Ø130mm)",
      "color": "#7C2D12",
      "assembled_z_offset": 0,
      "exploded_z_offset": 0,
      "parts": [
        {
          "id": "low_base",
          "label": "Low Threaded Base",
          "name": "Low Threaded Base",
          "groupId": 1,
          "colorKey": "low_base",
          "defaultColor": "#7C2D12",
          "assembled_z_offset": 0,
          "exploded_z_offset": 0,
          "export_stl": true
        }
      ]
    },
    {
      "id": "screw_obj",
      "label": "4x Male Screws / Feet",
      "name": "4x Male Screws / Feet",
      "color": "#9CA3AF",
      "assembled_z_offset": 0,
      "exploded_z_offset": -30,
      "parts": [
        {
          "id": "screw_feet",
          "label": "4x Male Feet Screws",
          "name": "4x Male Feet Screws",
          "groupId": 2,
          "colorKey": "screw_feet",
          "defaultColor": "#9CA3AF",
          "assembled_z_offset": 0,
          "exploded_z_offset": -30,
          "export_stl": true
        }
      ]
    }
  ],
  "exportGroups": [
    {
      "id": "all",
      "label": "Full Assembly STL",
      "groupId": -1
    },
    {
      "id": "base",
      "label": "Base Only STL",
      "groupId": 1
    },
    {
      "id": "shade",
      "label": "Lampshade Only STL",
      "groupId": 0
    },
    {
      "id": "ring",
      "label": "Locking Ring Only STL",
      "groupId": 3
    },
    {
      "id": "screws",
      "label": "4x Screws Only STL",
      "groupId": 2
    }
  ]
};
